
    
export function startTimer(countdownDuration, displayHours, displayMinutes, displaySeconds) {
    // var timer = duration, hours, minutes, seconds;
    timer = countdownDuration;
    if (interval) {
        clearInterval(interval); // Clear any existing interval
    }
    interval = setInterval(function () {
        var hours = parseInt(timer / 3600, 10)
        var minutes = parseInt((timer % 3600) / 60, 10);
        var seconds = parseInt(timer % 60, 10);

        displayHours.textContent = hours;
        displayMinutes.textContent = minutes;
        displaySeconds.textContent = seconds;

        displayHours.style.setProperty('--value', hours);
        displayMinutes.style.setProperty('--value', minutes);
        displaySeconds.style.setProperty('--value', seconds);

        if (--timer < 0) {
            timer = countdownDuration;
        }
    }, 1000);
}

// Reset the timer
export function resetTimer(countdownDuration, displayHours, displayMinutes, displaySeconds, interval) {
    if (interval) {
        clearInterval(interval); // Stop the interval
    }
    timer = countdownDuration;
    var hours = parseInt(timer / 3600, 10)
    var minutes = parseInt((timer % 3600) / 60, 10);
    var seconds = parseInt(timer % 60, 10);

    displayHours.textContent = hours;
    displayMinutes.textContent = minutes;
    displaySeconds.textContent = seconds;

    displayHours.style.setProperty('--value', hours);
    displayMinutes.style.setProperty('--value', minutes);
    displaySeconds.style.setProperty('--value', seconds);
    
}
